import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 03 Jan 2026 3:36 AM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.YVmwNzwwIh20_mYZDK07CaGZPv0bdV6lAxprfbX21SKl89IFcHL4lfQFjipZplAU54FeT8VNZ1rTep44_bDLBiACCjAaDNsJOshqqUdC3sx6ErZ5aBbM6MLCeHmYKyQq0DwLwvim8EG2EPMBWXjtJ_g8Zn0okptfrJV-vdIHpfAkVAj2mhoO3qMyfi5UNjxVEiYQJlJVO8pqbEhrPvU8dL6_eVkUpjYM47dTjRWCOH5ZOQUTDh9PM_1uVFKFbHcXqm8oQv_2-QORqSrMfFtoSFUHmC6mjqonS77en56mvyKQLbC8526_Y4OLex3UnPFvscAJKTmRh1J-PA1fkJyccIA0GrQv5OqVfw",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-01-10T02:36:36.669558Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-01-03T02:36:20+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.YVmwNzwwIh20_mYZDK07CaGZPv0bdV6lAxprfbX21SKl89IFcHL4lfQFjipZplAU54FeT8VNZ1rTep44_bDLBiACCjAaDNsJOshqqUdC3sx6ErZ5aBbM6MLCeHmYKyQq0DwLwvim8EG2EPMBWXjtJ_g8Zn0okptfrJV-vdIHpfAkVAj2mhoO3qMyfi5UNjxVEiYQJlJVO8pqbEhrPvU8dL6_eVkUpjYM47dTjRWCOH5ZOQUTDh9PM_1uVFKFbHcXqm8oQv_2-QORqSrMfFtoSFUHmC6mjqonS77en56mvyKQLbC8526_Y4OLex3UnPFvscAJKTmRh1J-PA1fkJyccIA0GrQv5OqVfw'

// {
//   "access_token": "v2.local.-mecSIOzIlsCi0fdEK7argE9-b1oXnARsBSnARYgpfmyKYPcQQLyE6WQlTli8H8nZfU5ixxsRSXkqmI2X-RQJm8rrMgD96eK51tJ3OrBHM_jMxD5B4MWdtIrEwn-d8OxyaOGMCM_88mZaNhInbV3ToRPaiuvJvOpdHgqaLjfTfc-DR0mN9Hbfjg2KYF01KC_slp4zl_d5m015gCdtjhfJxZcqf2U_1ASbPtFvgg0vbZd_SvI-Oe57wCA1fU017gjIrVOxKBJ8nIYE1Y2LC7yAxhMEXe_G_DgEa8MGuIx-GE7ldMWDeaimIeCatz9asDnWZWAfVYGksk4x8YgeJeMbXY5_5Mn",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-01-10T02:37:47.917989Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-01-03T02:37:44+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.-mecSIOzIlsCi0fdEK7argE9-b1oXnARsBSnARYgpfmyKYPcQQLyE6WQlTli8H8nZfU5ixxsRSXkqmI2X-RQJm8rrMgD96eK51tJ3OrBHM_jMxD5B4MWdtIrEwn-d8OxyaOGMCM_88mZaNhInbV3ToRPaiuvJvOpdHgqaLjfTfc-DR0mN9Hbfjg2KYF01KC_slp4zl_d5m015gCdtjhfJxZcqf2U_1ASbPtFvgg0vbZd_SvI-Oe57wCA1fU017gjIrVOxKBJ8nIYE1Y2LC7yAxhMEXe_G_DgEa8MGuIx-GE7ldMWDeaimIeCatz9asDnWZWAfVYGksk4x8YgeJeMbXY5_5Mn'

// {
//   "access_token": "v2.local.pT8q1e2AUFFeNniKlgtXhA5i-fyPn88jw5W3P-WOtsSNfxS6N1oh_qPk7v82k0Dl-V5JGljIaGCL2yD9iPC2Z2QD7vgTG_Bi3NB5HZ3V9k3vyshrIVNcb3ZVLew42gxdZ-CDLvhx-sfoFPvtc1NkzMw9s27S0sLOaodhXUN0M7N9ecOLLJTcOQH-PlWALw_5RKPn3MEq9azN4AEonb617Kc4QXG3DQoGAQrqMMkwwhhKT_SfUy9Omzy5KJzu6B0OTYsrQ2qwI5phqQnXFcbsr0qYqSW4roAyPzt2NkgyPTxh8MSxGZrP3_8KtDPWt1zXzgtBnPNDVzoGxDvLDNrNMVE3nrw",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-01-10T02:38:59.788682Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.pT8q1e2AUFFeNniKlgtXhA5i-fyPn88jw5W3P-WOtsSNfxS6N1oh_qPk7v82k0Dl-V5JGljIaGCL2yD9iPC2Z2QD7vgTG_Bi3NB5HZ3V9k3vyshrIVNcb3ZVLew42gxdZ-CDLvhx-sfoFPvtc1NkzMw9s27S0sLOaodhXUN0M7N9ecOLLJTcOQH-PlWALw_5RKPn3MEq9azN4AEonb617Kc4QXG3DQoGAQrqMMkwwhhKT_SfUy9Omzy5KJzu6B0OTYsrQ2qwI5phqQnXFcbsr0qYqSW4roAyPzt2NkgyPTxh8MSxGZrP3_8KtDPWt1zXzgtBnPNDVzoGxDvLDNrNMVE3nrw'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
